// @ts-nocheck
import React, { useState, useEffect, useContext, useMemo } from 'react';
import * as Enums from '@/utils/enums';
import Breadcrumbs from '@/components/breadcrumbs';
import { Box, Card, Tabs } from '@mantine/core';
import BillingService from "@/services/billing-service";
import SubscriptionContext from "@/utils/subscription-context";
import MessagesTable from "@/PageComponents/Table/Component Tables/MessagesTable";
import Helper from "@/utils/helper";
import { useRouter } from 'next/router';
import constants from "@/utils/constants";
import SCMessageBarContext from "@/utils/contexts/sc-message-bar-context";
import PS from '@/services/permission/permission-service';
import tabStyles from '@/styles/Tabs.module.css'
import BulkMessagesTable from '@/PageComponents/Table/Component Tables/BulkMessagesTable';
import storage from '@/utils/storage';
import NewText from "@/PageComponents/Premium/NewText";
import { createFileRoute } from '@tanstack/react-router'

export const allowBulkMessageForEveryone = true; // this turns bulk message on for everyone regardless of whitelist
export const bulkMessageWhiteList = [
    '22f67da6-b130-4333-acdb-a57b0f7d8b4c', // Amoroc Doors
    'c44accda-67c8-4da2-8cc5-045779fcad59', // Mayday technical cc
    'd3a1bff1-56f3-4cf6-8215-865825892e9e', // Transvaal Hydraulics
    '30aaa3bc-68b7-40a2-a3e8-3c441def2a51', // 6th Sense Security
    'e302fa64-5543-4e01-970b-6cabfb530fd7', // Westsmith Electrical 
    '1f0fdb52-a915-439f-a3d0-01247f9971f3', // R T E SECURITY
    //'88c693e4-0c2a-4902-a082-627510af80ef', // Thomas Electrical
    '49be95a2-2f15-414d-853f-27e6475d6be8', // Alto Door Manufacturers
    '74d180af-d216-4f87-ac71-f8433eb33d87', // Premier View
    '05a4828c-61ff-41d7-af0b-a32dd20001df', // FFMS
    '18f0c212-9fb0-4bb2-93eb-3d1cc30a1512', // Spinx
    '20b8e7c7-1cb4-49c1-bb08-11080fd7d886', // DroneTech
    '96a12fe5-8cfe-4662-b6de-bcdd57fc8024', // Pool Squad
    '4056b604-9baa-4671-af19-315b162ee931', // Ethemba Computers and Consulting
    
    
    '2dce8a8c-59d0-46b9-9132-30baad32a6f3', // Philco
    'ce1d433e-f42f-4eb0-a223-b3e206cfcda9', // Mouseco
    '6a3113cb-4a6b-478b-ac0c-b752cca572b8', // Edcorp
    '38cb9ccf-50ed-420c-84ac-fc08a61e7b09', // Baron Inc
]

function MessageList() {
    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None)
    const subscriptionContext = useContext(SubscriptionContext);
    const messageBarContext = useContext(SCMessageBarContext);
    const router = useRouter()

    const tabData = useMemo(() => {
        let tabsForPage = {
            messages: {
                label: 'Messages',
                access: PS.hasPermission(Enums.PermissionName.Message),
                newBadge: false
            }
        };

        const tenantID = storage.getCookie(Enums.Cookie.tenantID);

        if (allowBulkMessageForEveryone || bulkMessageWhiteList.includes(tenantID?.toLowerCase() ?? "")) {
            (tabsForPage as any).bulkMessages = {
                label: 'Bulk SMS',
                access: PS.hasPermission(Enums.PermissionName.Message),
                newBadge: false
            };
        }

        return tabsForPage;
    }, [])

    const getAccessStatus = async () => {
        const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext)
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus)
        }
    };

    useEffect(() => {
        const tab = router.query.tab as string // TODO(tanstack-router): verify router.query → useParams/useSearch
        if (tab && tabData[tab]) {
            setActiveTab(tab)
        }
        else {
            setActiveTab("messages");
        }

        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            console.log('no access', accessStatus, Enums.AccessStatus)
            Helper.nextRouter(router.replace, '/');
        }
    }, [accessStatus]);

    const [activeTab, setActiveTab] = useState<string | null>(Object.entries(tabData).find(([, x]: any) => x.access)?.[0] || '');

    const handleTabChange = (newTabName: string | null) => {
        setActiveTab(newTabName)
        router.replace(router.asPath.split('?')[0] + '?tab=' + newTabName)
    }

    const tabs = <>
        <Tabs color={'scBlue'} value={activeTab} onChange={handleTabChange}
            classNames={{
                tab: tabStyles.scTab,
                list: tabStyles.scTabList,
                tabLabel: tabStyles.scTabLabel
            }}
        >
            <Tabs.List mb={0} pb={0}>
                {
                    Object.entries(tabData).filter(([, x]: any) => true).map(
                        ([tabName, d]: any) => d && <Tabs.Tab value={tabName}
                            disabled={!d.access}
                            key={tabName + 'tab'}>
                            {d.label}
                            {d.newBadge && <NewText ml={5} />}
                        </Tabs.Tab>
                    )
                }
            </Tabs.List>
        </Tabs>
    </>

    return (
        <>
            <Box
                mt={'var(--mantine-spacing-sm)'}
                px={'var(--mantine-spacing-md)'}
                mb={0}
                pb={0}
                style={(theme: any) => ({ borderBottom: `${theme.colors.gray[2]} 2px solid` })}
            >
                <Box my={'var(--mantine-spacing-md)'}>
                    <Breadcrumbs currPage={{
                        text: tabData[activeTab || '']?.label,
                        link: `/message/list?tab=${activeTab || ''}`,
                        type: 'list'
                    }} />
                </Box>

                {tabs}

            </Box>
            <Box
                h={`calc(100vh - 142px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                style={(theme: any) => ({
                    backgroundColor: theme.colors.gray[1]
                })}
                p={'var(--mantine-spacing-xs)'}
                pb={constants.chatWidgetSafeArea}
            >
                <Card
                    style={{
                        backgroundColor: 'white'
                    }}
                    p={'var(--mantine-spacing-md)'}
                    radius={'md'}
                >
                    {
                        activeTab === 'messages' &&
                        <MessagesTable /> ||
                        activeTab === 'bulkMessages' &&
                        <BulkMessagesTable />
                    }
                </Card>

            </Box>

        </>
    )

}

export default MessageList;

export const Route = createFileRoute('/_authenticated/message/list')({ component: MessageList })
